<template>
  <v-list-group :value="false" active-class="primary white--text">
    <template v-slot:activator>
      <v-list-item-icon class="mr-4">
        <v-icon>mdi-format-list-bulleted-square</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Lớp bán trú</v-list-item-title>
    </template>
    <v-list class="py-0">
      <v-list-item active-class="blue lighten-4 primary--text" class="px-0" link to="/boarding-class">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Danh sách</v-list-item-title>
      </v-list-item>
      <v-list-item v-if="$_get(role, 'type') === 'manager'" active-class="blue lighten-4 primary--text" class="px-0" link to="/boarding-class-session">
        <v-list-item-action />
        <v-list-item-title>Điểm danh</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-list-group>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters('auth', ['role']),
  },
}
</script>
